const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: '#555',
    marginBottom: '12px',
    transition: 'opacity 300ms ease-in-out'
  },
  avatar: {
    fontSize: '30px',
    color: '#fff',
    marginRight: '10px'
  },
  name: {
    fontSize: '16px'
  }
}

export default styles
